import React, { useState } from 'react';
import axios from 'axios';

const ImageUploader = () => {
  const [fileInputs, setFileInputs] = useState({
    oleksandra: null,
    kristina: null,
    yurii: null,
    polina: null,
  });
  const [loading, setLoading] = useState({
    oleksandra: false,
    kristina: false,
    yurii: false,
    polina: false,
  });
  const [notification, setNotification] = useState(null);

  const teamMembers = [
    { name: 'Oleksandra Misiats', key: 'oleksandra' },
    { name: 'Kristina Kamardina', key: 'kristina' },
    { name: 'Yurii Shapoval', key: 'yurii' },
    { name: 'Polina Frishko', key: 'polina' },
  ];

  const handleFileChange = (key) => (e) => {
    setFileInputs((prev) => ({
      ...prev,
      [key]: e.target.files[0],
    }));
  };

  const handleImageUpload = async (image) => {
    const formData = new FormData();
    formData.append('file', image);
    formData.append('upload_preset', 'ml_default');

    try {
      const res = await axios.post(
        'https://api.cloudinary.com/v1_1/dca5poo9m/image/upload',
        formData
      );
      return res.data.secure_url;
    } catch (error) {
      console.error('Помилка завантаження зображення:', error);
      return '';
    }
  };

  const uploadImage = async (file, memberKey) => {
    if (!file) return;

    setLoading((prev) => ({ ...prev, [memberKey]: true }));

    try {
      const imageUrl = await handleImageUpload(file);
      if (!imageUrl) {
        throw new Error('Не вдалося отримати URL зображення');
      }

      const serverBaseUrl = process.env.REACT_APP_SERVER_BASE_URL || 'http://localhost:5000';
      await axios.post(`${serverBaseUrl}/api/team-images`, {
        member: memberKey,
        imageUrl,
      });

      setNotification(`Зображення для ${memberKey} успішно завантажено!`);
      setFileInputs((prev) => ({ ...prev, [memberKey]: null }));
      setTimeout(() => setNotification(null), 3000);
    } catch (error) {
      console.error('Помилка завантаження:', error);
      setNotification('Помилка при завантаженні зображення');
      setTimeout(() => setNotification(null), 3000);
    } finally {
      setLoading((prev) => ({ ...prev, [memberKey]: false }));
    }
  };

  const handleSubmit = (key) => (e) => {
    e.preventDefault();
    uploadImage(fileInputs[key], key);
  };

  return (
    <div className="image_uploader">
      <h2>Завантаження зображень команди</h2>
      {teamMembers.map((member) => (
        <div className='image_uploader-item' key={member.key}>
          <p className="col_title">{member.name}</p>
          <form onSubmit={handleSubmit(member.key)}>
            <input
              type="file"
              accept="image/*"
              onChange={handleFileChange(member.key)}
            />
            <button type="submit" disabled={!fileInputs[member.key] || loading[member.key]}>
              {loading[member.key] ? (
                <span className="loading-dots">Завантаження<span>.</span><span>.</span><span>.</span></span>
              ) : (
                'Завантажити'
              )}
            </button>
          </form>
        </div>
      ))}
      {notification && <div className="notification">{notification}</div>}
    </div>
  );
};

export default ImageUploader;